import { render } from "./PropertyDataAndFacts.vue?vue&type=template&id=fd6fa238"
import script from "./PropertyDataAndFacts.vue?vue&type=script&lang=js"
export * from "./PropertyDataAndFacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__